import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IGanttTogglerHOCProps } from './types';
import { onChange } from './events/onChange';
import { getBoard } from '../../../../../../../../store/model/selectors/getBoardById';
import { ISectionTogglerEvents, ISectionTogglerFields } from '../../../../../../base/components/SectionToggler/types';
import { SectionToggler } from '../../../../../../base/components/SectionToggler/SectionToggler';
import { onClickDisallow } from './events/onClickDisallow';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IGanttTogglerHOCProps
): ISectionTogglerFields => {
    const { showOnGantt: checked } = getBoard(state, boardId);
    const sectionType = getSectionType(state, boardId, null, 'allowGantt');
    const isDisabled = sectionType === ESettingsSectionType.READONLY;
    const isDisallowed = sectionType === ESettingsSectionType.DISALLOW;
    return {
        checked,
        isDisabled,
        isDisallowed,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IGanttTogglerHOCProps
): ISectionTogglerEvents => {
    return {
        onChange: () => dispatch(onChange(boardId)),
        onClickDisabled: () => dispatch(showBoardLimitSnackbarIfNeeded()),
        onClickDisallow: () => dispatch(onClickDisallow()),
    }
};

export const GanttTogglerHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionToggler);

GanttTogglerHOC.displayName = 'GanttTogglerHOC';
